/**
 * Stripe产品ID常量
 * 用于处理Stripe支付和订阅
 */

// 生产环境API积分产品ID
export const STRIPE_PRICE_API_CREDITS_PROD = {
  // 一次性购买API积分
  STRIPE_PRICE_API_ONETIME_300CREDITS: 'price_1RGsThCTvl6RcHnIodPgLRlR',
  STRIPE_PRICE_API_ONETIME_500CREDITS: 'price_1RGsTyCTvl6RcHnInuNF9Vkg',
  STRIPE_PRICE_API_ONETIME_1000CREDITS: 'price_1RGsUMCTvl6RcHnI3tJMRHvE',
  STRIPE_PRICE_API_ONETIME_2500CREDITS: 'price_1RGsUuCTvl6RcHnIjteTHjbh',
  STRIPE_PRICE_API_ONETIME_5000CREDITS: 'price_1RGsVCCTvl6RcHnICkbXtlfX',
  STRIPE_PRICE_API_ONETIME_10000CREDITS: 'price_1RGsVUCTvl6RcHnIWt8tWTmN',
  STRIPE_PRICE_API_ONETIME_25000CREDITS: 'price_1RGsWECTvl6RcHnIkFTndEjX',
};

// 开发环境API积分产品ID
export const STRIPE_PRICE_API_CREDITS_DEV = {
  // 一次性购买API积分
  STRIPE_PRICE_API_ONETIME_300CREDITS: 'price_1RGuNGCTvl6RcHnIln4z4tma',
  STRIPE_PRICE_API_ONETIME_500CREDITS: 'price_1RGuMrCTvl6RcHnIMgqqFNcg',
  STRIPE_PRICE_API_ONETIME_1000CREDITS: 'price_1RGuMVCTvl6RcHnIWuURcu4X',
  STRIPE_PRICE_API_ONETIME_2500CREDITS: 'price_1RGuMACTvl6RcHnIC7aMCe9O',
  STRIPE_PRICE_API_ONETIME_5000CREDITS: 'price_1RGuLdCTvl6RcHnIAEpLYYSp',
  STRIPE_PRICE_API_ONETIME_10000CREDITS: 'price_1RGuLFCTvl6RcHnISeuHdmKA',
  STRIPE_PRICE_API_ONETIME_25000CREDITS: 'price_1RGuKfCTvl6RcHnIsOlj4Q0R',
};

// 根据当前环境选择对应的产品ID
export const STRIPE_PRICE_API_CREDITS =
  process.env.NEXT_PUBLIC_ENV === 'prod'
    ? STRIPE_PRICE_API_CREDITS_PROD
    : STRIPE_PRICE_API_CREDITS_DEV;

// 将产品名映射到产品ID - 生产环境
export const STRIPE_PRODUCT_MAP_PROD: Record<string, string> = {
  STRIPE_PRICE_API_ONETIME_300CREDITS:
    STRIPE_PRICE_API_CREDITS_PROD.STRIPE_PRICE_API_ONETIME_300CREDITS,
  STRIPE_PRICE_API_ONETIME_500CREDITS:
    STRIPE_PRICE_API_CREDITS_PROD.STRIPE_PRICE_API_ONETIME_500CREDITS,
  STRIPE_PRICE_API_ONETIME_1000CREDITS:
    STRIPE_PRICE_API_CREDITS_PROD.STRIPE_PRICE_API_ONETIME_1000CREDITS,
  STRIPE_PRICE_API_ONETIME_2500CREDITS:
    STRIPE_PRICE_API_CREDITS_PROD.STRIPE_PRICE_API_ONETIME_2500CREDITS,
  STRIPE_PRICE_API_ONETIME_5000CREDITS:
    STRIPE_PRICE_API_CREDITS_PROD.STRIPE_PRICE_API_ONETIME_5000CREDITS,
  STRIPE_PRICE_API_ONETIME_10000CREDITS:
    STRIPE_PRICE_API_CREDITS_PROD.STRIPE_PRICE_API_ONETIME_10000CREDITS,
  STRIPE_PRICE_API_ONETIME_25000CREDITS:
    STRIPE_PRICE_API_CREDITS_PROD.STRIPE_PRICE_API_ONETIME_25000CREDITS,
};

// 将产品名映射到产品ID - 开发环境
export const STRIPE_PRODUCT_MAP_DEV: Record<string, string> = {
  STRIPE_PRICE_API_ONETIME_300CREDITS:
    STRIPE_PRICE_API_CREDITS_DEV.STRIPE_PRICE_API_ONETIME_300CREDITS,
  STRIPE_PRICE_API_ONETIME_500CREDITS:
    STRIPE_PRICE_API_CREDITS_DEV.STRIPE_PRICE_API_ONETIME_500CREDITS,
  STRIPE_PRICE_API_ONETIME_1000CREDITS:
    STRIPE_PRICE_API_CREDITS_DEV.STRIPE_PRICE_API_ONETIME_1000CREDITS,
  STRIPE_PRICE_API_ONETIME_2500CREDITS:
    STRIPE_PRICE_API_CREDITS_DEV.STRIPE_PRICE_API_ONETIME_2500CREDITS,
  STRIPE_PRICE_API_ONETIME_5000CREDITS:
    STRIPE_PRICE_API_CREDITS_DEV.STRIPE_PRICE_API_ONETIME_5000CREDITS,
  STRIPE_PRICE_API_ONETIME_10000CREDITS:
    STRIPE_PRICE_API_CREDITS_DEV.STRIPE_PRICE_API_ONETIME_10000CREDITS,
  STRIPE_PRICE_API_ONETIME_25000CREDITS:
    STRIPE_PRICE_API_CREDITS_DEV.STRIPE_PRICE_API_ONETIME_25000CREDITS,
};

// 根据当前环境选择对应的产品映射
export const STRIPE_PRODUCT_MAP =
  process.env.NEXT_PUBLIC_ENV === 'prod'
    ? STRIPE_PRODUCT_MAP_PROD
    : STRIPE_PRODUCT_MAP_DEV;
